<script setup>
import { onMounted, ref, useAttrs } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const attrs = useAttrs();
const showFooter = ref(false);
const isDesktop = ref(false);

const updateWindowSize = () => {
    isDesktop.value = window.innerWidth >= 768;
    if (isDesktop.value) {
        showFooter.value = true;
    } else {
        showFooter.value = false;
    }
};

// 푸터 토글 함수
const toggleFooter = () => {
    showFooter.value = !showFooter.value;
};

// 이벤트 등록 및 해제
onMounted(() => {
    updateWindowSize();
    window.addEventListener('resize', updateWindowSize);
});
</script>

<template>
    <footer class="bg-gray-100 border-t border-gray-300 py-8">
        <div class="container mx-auto px-4">
            <div class="flex flex-wrap items-center justify-start md:justify-start space-x-4 mb-3">
                <ul class="flex flex-wrap space-x-4">
                    <li><b @click="router.push('/privacytreat')" class="cursor-pointer text-[#646464] hover:text-blue-600 text-[0.875rem]">개인정보처리방침</b></li>
                    <li><b @click="router.push('/terms')" class="ml-2 cursor-pointer text-[#646464] hover:text-blue-600 text-[0.875rem]">이용약관</b></li>
                    <li><b @click="router.push('/system/introduce')" class="ml-2 cursor-pointer text-[#646464] hover:text-blue-600 text-[0.875rem]">회사소개</b></li>
                    <li><b @click="router.push('/system/information')" class="ml-2 cursor-pointer text-[#646464] hover:text-blue-600 text-[0.875rem]">이용안내</b></li>
                </ul>
            </div>

            <div class="flex flex-wrap items-center justify-between text-[0.8rem] text-gray-600 mb-1">
                사업자. 곰두리렌터카(주)<br />
                대표이사. 이춘이<br />
                주소. 울산광역시 동구 후릉길 1(방어동, 101호)<br />
                사업자 번호. 609-81-86274<br />
                통신판매업신고번호. 제2017-울산동구-00125호<br />
                대표번호. 1551-2295
                <!-- Copyrightⓒ 2025 곰두리렌터카. All Rights Reserved. -->
            </div>
            <div class="text-left text-[0.73rem] text-gray-400">Copyrightⓒ 2025 곰두리렌터카. All Rights Reserved.</div>
            <!-- <div class="flex justify-center md:justify-end space-x-4 mb-6">ㅇㅇㅇ</div> -->
        </div>
    </footer>
</template>

<style scoped>
.layout-footer {
    width: 100%;
    background-color: #f2f2f2;
    border-top: 1px solid #ddd;
    opacity: 0.9;
    position: relative;
    bottom: 0;
    display: flex;
    justify-content: center;
    padding: 1rem 0;
}

.f-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}

.f_info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.f_info li {
    font-size: 0.75rem;
    line-height: 1.4;
    color: #181818;
    margin: 4px 0;
    padding: 0;
}

.f_info li:first-child,
.f_info li:last-child {
    width: 100%;
}

@media (max-width: 768px) {
    .layout-footer {
        padding: 1rem 0.5rem;
    }
    .f-container {
        max-width: 100%;
        padding: 0 0.5rem;
    }
    .f_info li {
        font-size: 0.7rem;
        line-height: 1.3;
    }
}
</style>
